module.exports = __webpack_public_path__ + "1fa94ecf22392587c98e5cff099a1eff.svg";